import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { knockClient } from "../utils/knockClient";
import { preferencesQueryKey } from "./preferencesQuery";

export const usePreferencesMutation = () => {
    const copy = useProfileCopy();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data) => {
            const host = window.location.hostname;
            if (host === "localhost" || host === "127.0.0.1") {
                return { channel_types: data };
            }
            return knockClient.user.setPreferences({ channel_types: data });
        },
        onSuccess: (data) => {
            // Invalidate and refetch preferences
            queryClient.invalidateQueries(preferencesQueryKey);
            toast.success(copy.notificationPreferencesSaved);
            return data;
        },
        onError: () => {
            toast.error(copy.notificationPreferencesSaveFailed);
        },
    });
};
